import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';
import { notify } from '@/core/toast/notify';
import { getRevertPath } from '@/utils/routeAccess';
import { useAppSelector } from '@/hooks/useAppSelector';
import { resolveOwnerHomePath } from '@/utils/moduleAccess';

export function UnknownRouteHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const enabledModules = useAppSelector((s) => s.auth.enabledModules);
  const entryModule = useAppSelector((s) => s.auth.entryModule);

  useEffect(() => {
    const fallback = entryModule
      ? getRevertPath(location.pathname, MODULE_HUB_PATH)
      : getRevertPath(location.pathname, resolveOwnerHomePath(enabledModules));
    notify.error('This page does not exist.');
    navigate(fallback, { replace: true });
  }, [location.pathname, navigate, enabledModules, entryModule]);

  return null;
}
